import Link from 'next/link';
import React, { AnchorHTMLAttributes, ButtonHTMLAttributes, FC } from 'react';

export type ButtonProps = AnchorHTMLAttributes<HTMLAnchorElement>;

const Button: FC<ButtonProps> = ({ href, children, className, ...props }) => {
  // If no valid URL, render as button element instead of anchor
  if (!href) {
    return (
      <button type="button" className={className} {...(props as ButtonHTMLAttributes<HTMLButtonElement>)}>
        {children}
      </button>
    );
  }

  // Valid URL - render as anchor for SEO
  return (
    <Link href={href} className={className} {...props}>
      {children}
    </Link>
  );
};

export default Button;
